import { jsx as _jsx } from "react/jsx-runtime";
import { ConnectedRouter } from 'connected-react-router';
import { CompatRouter } from 'react-router-dom-v5-compat';
import { createRoot } from 'react-dom/client';
import { ReduxContextWrapper, ApolloContextWrapper } from 'web-app/react/contexts/common';
import { installFindDOMNodeShim } from '@famly/vet_ts-utils_react-dom-shim';
import ContextProvider from 'signin-app/components/context';
import ScrollToTopOnRouteChange from 'shared/components/scroll-to-top-route';
import setupSentry from 'signin-app/setup/sentry-setup';
import store, { history } from 'signin-app/redux/store';
import { client } from 'signin-app/api/clients/apollo-client';
import { setupMoment } from 'web-app/setup/moment-setup';
import App from './app';
// React 19 removed ReactDOM.findDOMNode, which some legacy dependencies (react-transition-group)
// still call internally. Re-expose it before anything renders.
installFindDOMNodeShim();
// The Sentry SDK should be initialized as early as possible on app startup.
setupSentry();
setupMoment();
const RouterContextWrapper = (InnerComponent, history) => props => {
    return (_jsx(ConnectedRouter, { history: history, children: _jsx(CompatRouter, { children: _jsx(InnerComponent, { ...props }) }) }));
};
const ContextProviderWrapped = () => (_jsx(ContextProvider, { children: _jsx(App, {}) }));
const ScrollToTopWrapped = ScrollToTopOnRouteChange(ContextProviderWrapped);
// RouterWrapped must be InnerComponent of ReduxContextWrapper
const RouterWrapped = RouterContextWrapper(ScrollToTopWrapped, history);
const ReduxWrapped = ReduxContextWrapper(RouterWrapped, store);
const ApolloWrapped = ApolloContextWrapper(ReduxWrapped, client);
createRoot(document.getElementById('root') || document.createElement('div')).render(_jsx(ApolloWrapped, {}));
if (module.hot) {
    module.hot.accept();
}
export default ApolloWrapped;
